export default {
  // City-related mutations
  SET_AVAILABLE_CITIES(state, cities) {
    state.cities.available = cities;
  },

  SET_CITIES_LOADED(state, loaded) {
    state.cities.loaded = !!loaded;
  },

  SET_SELECTED_CITY(state, city) {
    state.cities.selected = city;
  },

  CLEAR_CITY_SELECTION(state) {
    state.cities.selected = null;
  },

  // Reset selections when city changes
  RESET_SELECTIONS_FOR_CITY_CHANGE(state) {
    state.activityGroups.selected = false;
    state.activities.selected = false;
    state.selectedSlot = false;
    state.providers.selected = false;
    state.providers.available = [];
    state.locations.selected = false;
    state.locations.available = [];
    state.availableTimes = [];
    state.loadedTimes = [];
  },
};
